import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  spacing: 8, // Fix spacing issue
  overrides: {
    MuiButton: {
      containedPrimary: {
        backgroundColor: '#ffa300',
        color: '#ffffff',
        '&:hover': {
          backgroundColor: '#ff8b00'
        }
      },
      containedSecondary: {
        backgroundColor: '#dc004e',
        color: '#ffffff',
        '&:hover': {
          backgroundColor: '#c51162'
        }
      }
    },
    MuiTableCell: {
      root: {
        padding: '6px 10px'
      }
    }
  }
});

export default theme;
